/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const SPA_REFERRER_STORAGE_KEY = 'mbp_spa_referrer';

const canUseSessionStorage = () => typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

export const buildLocationPath = (location = {}) => `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;

export const readSpaReferrerState = () => {
    if (!canUseSessionStorage()) {
        return {
            currentPath: '',
            previousPath: '',
        };
    }

    try {
        const storedValue = sessionStorage.getItem(SPA_REFERRER_STORAGE_KEY);
        if (!storedValue) {
            return {
                currentPath: '',
                previousPath: '',
            };
        }

        return JSON.parse(storedValue);
    } catch (error) {
        return {
            currentPath: '',
            previousPath: '',
        };
    }
};

export const writeSpaReferrerState = (state) => {
    if (!canUseSessionStorage()) {
        return;
    }

    sessionStorage.setItem(SPA_REFERRER_STORAGE_KEY, JSON.stringify(state));
};

export const updateSpaReferrer = (location) => {
    if (typeof window !== 'undefined') {
        window.gtmPvFired = false;
    }
    const nextPath = buildLocationPath(location);

    if (!nextPath) {
        return;
    }

    const currentState = readSpaReferrerState();

    if (currentState.currentPath === nextPath) {
        return;
    }

    writeSpaReferrerState({
        currentPath: nextPath,
        previousPath: currentState.currentPath || '',
    });
};

export const getDocumentReferrer = () => {
    if (typeof document === 'undefined') {
        return '';
    }

    return document.referrer || '';
};

export const getPreviousLocation = () => readSpaReferrerState().previousPath || '';

export const getSpaReferrer = () => getPreviousLocation() || getDocumentReferrer();
